import { JournalPanel } from "../components/JournalPanel";

export function JournalPage() {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl font-bold tracking-tight">Journal</h1>
      <JournalPanel />
    </div>
  );
}
